
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper';
Swiper.use([Navigation, Pagination, Autoplay])

//mobile menu toggle
document.getElementById('hamburgerToggle').onclick = () => {
    document.getElementById('hamburger').classList.toggle('is-active'),
    document.getElementById('mobileMenu').classList.toggle('mobile__menu--show'),
    document.getElementById('site-header').classList.toggle('header-mobile')
  }

// Home banner carousel

new Swiper('#home-banner-carousel', {
    slidesPerView: 1,
    autoplay: {
      delay: 7500,
      disableOnInteraction: false,
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
  })

new Swiper('#testimonial-carousel', {
    slidesPerView: 1,
    autoplay: {
      delay: 7500,
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: '.testimonial-carousel-next',
      prevEl: '.testimonial-carousel-prev',
    },
})
  
  
new Swiper('#client-carousel', {
    slidesPerView: 1,
    loop: true,
    spaceBetween: 30,
    autoplay: true,
    navigation: {
      nextEl: '.logo-carousel-next',
      prevEl: '.logo-carousel-prev',
    },
    breakpoints: {
      1200: {
        slidesPerView: 5,
      },

      768: {
        slidesPerView: 3.5,
      },

      500: {
        slidesPerView: 2,
      },
    },
  })
  
  new Swiper('#team-member-carousel', {
    slidesPerView: 1.5,
    autoplay: {
      delay: 7500,
      disableOnInteraction: false,
    },
    breakpoints: {
      600: {
        slidesPerView: 2,
      },

      1024: {
        enabled: false,
      },
    },
  })

  var modalbuttons = document.querySelectorAll(".team-member__modal-link");

  modalbuttons.forEach((element)=>{

    let modal = document.getElementById(element.dataset.toggle)

    element.addEventListener("click", ()=>{

      modal.style.display = "flex";

    })

    console.log(element, element.dataset, element.dataset.toggle)

    let close = modal.getElementsByClassName("team-member__modal-close")[0]

    close.addEventListener("click", ()=>{

      modal.style.display = "none";

    })

  })

//search toggle

document.getElementById('search-toggle').onclick = () => {
  document.getElementById('search-container').classList.toggle('search__container-open')
}

document.getElementById('search-close').onclick = () => {
  document.getElementById('search-container').classList.toggle('search__container-open')
}
